import { config, hammerIt } from '../../../utilities';
import initPins from '../../common/aerial-map';

export default function initMobileAerialMapPopup() {
    const $popupImgOuter = $('.popup .aerial-map__img-outer');
    if (!$popupImgOuter.length) {
        return;
    }
    // const minH = 750;
    const h = $popupImgOuter.outerHeight();
    const imgW = h / config.aerialMap.aspectRatio;
    const defaultScrollLeft = (imgW - $popupImgOuter.outerWidth()) / 2;
    const defaultScrollTop = (h - $popupImgOuter.outerHeight()) / 2;
    $popupImgOuter.find('.aerial-map__img-container').css('width', imgW);
    $popupImgOuter.scrollLeft(defaultScrollLeft);
    $popupImgOuter.scrollTop(defaultScrollTop);

    initPins($popupImgOuter.find('.aerial-map__pin'), imgW);
    // pinch zoom
    hammerIt(document.querySelector('.popup .aerial-map__img-outer'), 1, 2);

    function fadeOutIntro() {
        const $popupIntro = $popupImgOuter.find('.aerial-map__popup-intro');
        $popupIntro.find('.icon').addClass('text-fade-out');
        $popupIntro.find('.heading').addClass('text-fade-out');
        $popupImgOuter.off('touchstart', fadeOutIntro);
    }

    $popupImgOuter.on('touchstart', fadeOutIntro);
}
